var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOvhColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 298.03 47.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "OVHcloud_master_logo_fullcolor_RGB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.11,40.31a40.1,40.1,0,0,1-3.74,44.49H84.93l6.6-11.67H82.8L93.09,55h8.78l8.24-14.67ZM67.77,84.8H45.91a39.59,39.59,0,0,1-3.79-44.59L56.3,64.84,71.93,37.62h23L67.78,84.78h0v0Z",
    transform: "translate(-36.97 -37.62)",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.18,62.9c0-12.59,6.27-18.64,16.57-18.64s16.56,6.05,16.56,18.64S155,81.47,144.75,81.47,128.18,75.37,128.18,62.9Zm3.72,0c0,10.35,4.72,15.28,12.85,15.28s12.84-4.93,12.84-15.28-4.72-15.35-12.84-15.35S131.9,52.49,131.9,62.9Z",
    transform: "translate(-36.97 -37.62)",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M188.38,45.75a1.82,1.82,0,0,1,1.7-1.17,1.79,1.79,0,0,1,1.8,1.81,2.42,2.42,0,0,1-.16.79L179.3,79.93a1.78,1.78,0,0,1-3.39,0L163.49,47.18a2.42,2.42,0,0,1-.16-.79,1.79,1.79,0,0,1,1.8-1.81,1.82,1.82,0,0,1,1.7,1.17L177.6,74.31Z",
    transform: "translate(-36.97 -37.62)",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M199.42,64.06V79.35a1.81,1.81,0,1,1-3.61,0v-33a1.81,1.81,0,1,1,3.61,0V60.77H217.9V46.39a1.81,1.81,0,1,1,3.61,0v33a1.81,1.81,0,1,1-3.61,0V64.06Z",
    transform: "translate(-36.97 -37.62)",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M238.55,55.89a10,10,0,0,1,8.17,3.66,1.56,1.56,0,0,1,.37,1,1.51,1.51,0,0,1-1.54,1.54,1.56,1.56,0,0,1-1.27-.64A6.8,6.8,0,0,0,238.55,59c-4.89,0-7.49,3.13-7.49,9.66s2.6,9.71,7.49,9.71a9.68,9.68,0,0,0,6.15-2.28,1.56,1.56,0,0,1,1-.37,1.54,1.54,0,0,1,1.54,1.54,1.63,1.63,0,0,1-.69,1.32,12.06,12.06,0,0,1-8,2.87c-6.85,0-10.94-4.09-10.94-12.79S231.7,55.89,238.55,55.89Z",
    transform: "translate(-36.97 -37.62)",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M255.48,44.63V75c0,2.12.69,3,2.12,3a1.6,1.6,0,1,1,0,3.19c-3.55,0-5.52-2.13-5.52-6.21V44.63a1.74,1.74,0,0,1,1.7-1.69A1.7,1.7,0,0,1,255.48,44.63Z",
    transform: "translate(-36.97 -37.62)",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M284.41,68.63c0,8.7-4.25,12.79-11.15,12.79s-11.14-4.09-11.14-12.79,4.3-12.74,11.14-12.74S284.41,59.92,284.41,68.63Zm-3.45,0c0-6.69-2.81-9.66-7.7-9.66s-7.69,3-7.69,9.66,2.81,9.71,7.69,9.71S281,75.42,281,68.63Z",
    transform: "translate(-36.97 -37.62)",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M292.59,57.91V71.76c0,3.45,1.11,6.42,6.47,6.42s6.48-3,6.48-6.42V57.91a1.72,1.72,0,0,1,1.75-1.7,1.67,1.67,0,0,1,1.65,1.7V71.76c0,5-1.65,9.66-9.88,9.66s-9.87-4.62-9.87-9.66V57.91a1.67,1.67,0,0,1,1.7-1.7A1.71,1.71,0,0,1,292.59,57.91Z",
    transform: "translate(-36.97 -37.62)",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M331.6,59.34V44.63a1.7,1.7,0,0,1,3.4,0V71c0,7-4.35,10.46-10.4,10.46-6.85,0-10.89-4.09-10.89-12.79s3.83-12.74,10.67-12.74A9,9,0,0,1,331.6,59.34Zm0,4.3s-2-4.67-7-4.67-7.49,3.13-7.49,9.66,2.6,9.71,7.49,9.71c4.08,0,7-2.33,7-7.38Z",
    transform: "translate(-36.97 -37.62)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOvhColor);
export default __webpack_public_path__ + "static/media/ovh-color.bd7a12b4536beff680a978ac77256ff4.svg";
export { ForwardRef as ReactComponent };